module.exports = __webpack_public_path__ + "img/touxian.f9caf84b.jpeg";